import React, { Component } from 'react';

import defaultStyles from './default.less';

interface Props extends Omit<React.HTMLProps<HTMLInputElement>, 'ref'> {
	// eslint-disable-next-line no-use-before-define
	ref?: React.Ref<Input>;
	isInvalid: boolean;
	autoFocus: boolean;
	type: string;
	styles: {
		default?: string;
		invalid?: string;
		clearButton?: string;
		clearable?: string;
	};
	onClear?(): void;
}

export default class Input extends Component<Props> {
	static defaultProps = {
		isInvalid: false,
		autoFocus: false,
		type: 'text',
		styles: defaultStyles,
	};

	element = React.createRef<HTMLInputElement>();

	componentDidMount() {
		if (this.props.autoFocus) {
			this.focus();
		}
	}

	focus() {
		if (this.element.current !== null) {
			this.element.current.focus();
		}
	}

	selectAllText() {
		if (this.element.current !== null) {
			this.element.current.setSelectionRange(0, this.element.current.value.length);
		}
	}

	render() {
		const { isInvalid, onClear, type, styles, ...props } = this.props;
		const className = `${onClear !== undefined ? styles.clearable : ''} ${isInvalid ? styles.invalid : styles.default}`;

		const { autoFocus, ...inputProps } = props;

		const input = <input className={className} type={type} {...inputProps} ref={this.element} />;

		return onClear !== undefined ? (
			<span style={{ position: 'relative' }}>
				{input}
				<div className={styles.clearButton} role='button' onClick={onClear}>
					×
				</div>
			</span>
		) : (
			input
		);
	}
}
